// Shared client for /api/* calls that need a Clerk session token.
// A small bridge component (mounted inside <ClerkProvider>) calls
// setApiTokenGetter(getToken) on mount, after which every request
// routed through authenticatedFetch attaches Authorization: Bearer.
//
// Body: pass options.body the same way you would to fetch(). The
// helper does NOT auto-stringify or auto-set Content-Type when body
// is a FormData — that case is detected and left alone so the
// browser sets the multipart boundary.

let tokenGetter = null;

export function setApiTokenGetter(fn) {
  tokenGetter = fn;
}

async function getAuthHeader() {
  if (!tokenGetter) return {};
  try {
    const token = await tokenGetter();
    if (token) return { Authorization: `Bearer ${token}` };
  } catch {
    // If the token fetch fails we fall through to no header — the
    // server will respond 401 and the caller surfaces that.
  }
  return {};
}

export async function authenticatedFetch(url, options = {}) {
  const incoming = options.headers || {};
  const isFormData =
    typeof FormData !== 'undefined' && options.body instanceof FormData;

  const headers = isFormData
    ? { ...incoming }
    : { 'Content-Type': 'application/json', ...incoming };

  Object.assign(headers, await getAuthHeader());

  return fetch(url, { ...options, headers });
}
